import React, { useState } from "react";
import Layout from "../layout/DefaultLayout";
import { Container, Card, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api from "../utils/helper";
import { useQuery } from "react-query";
import Footer from "../components/Footer";
import { useIDsContext } from "../context/IDsContext";

const Colleges = () => {
  const navigate = useNavigate();

  const { data, isLoading, error } = useQuery(["vendors", "/vendors"], () =>
    api.get("/super-admin/vendors").then((res) => {
      console.log("API Response:", res.data); // Log response
      return res.data.data;
    })
  );

  const vendors = data || [];

  // State to store selected vendor ID
  const [selectedVendor, setSelectedVendor] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { setVendorID, setVendorName } = useIDsContext();

  const handleCollegeList = () => {
    if (!selectedVendor) {
      setErrorMessage("Please select a vendor.");
      return;
    }
    setErrorMessage("");

    const selectedVendorData = vendors.find(
      (vendorObj) => vendorObj?.vendor?._id === selectedVendor
    );

    const vendorName = selectedVendorData?.vendor?.name;

    console.log("vendor._id", selectedVendor);
    setVendorID(selectedVendor);
    console.log("vendor.vendorName:", selectedVendor);
    setVendorName(vendorName);
    navigate("/college-list", {
      state: { vendorId: selectedVendor, vendorName },
    });
  };

  return (
    <Layout>
      <Container fluid className="main-container mt-0 mt-md-4 ps-auto ps-md-0">
        <Card className="main-card">
          <Card.Body>
            <div className="d-flex justify-content-center align-items-center h-100">
              <div className="vendor-card">
                <h4 className="text-center mb-4 collhead">Colleges</h4>

                <Card>
                  <Card.Body>
                    <Form>
                      <Form.Group controlId="selectVendor" className="mb-4">
                        <Form.Label
                          className="collhead"
                          style={{ opacity: "inherit" }}
                        >
                          Select Vendor
                        </Form.Label>
                        <Form.Select
                          value={selectedVendor}
                          onChange={(e) => setSelectedVendor(e.target.value)}
                        >
                          {/* {console.log(vendors.forEach((vendor) => console.log("Vendor:", vendor)), "ok8")} */}
                          <option value="">Select Vendor</option>
                          {vendors.length > 0 ? (
                            vendors.map(
                              ({ vendor }) =>
                                vendor && (
                                  <option key={vendor._id} value={vendor._id}>
                                    {console.log(vendor._id, "iii")}
                                    {vendor.name}
                                  </option>
                                )
                            )
                          ) : (
                            <option disabled>No vendors available</option>
                          )}
                        </Form.Select>
                        {/* Validation Error Message */}
                        {errorMessage && (
                          <Form.Control.Feedback
                            type="invalid"
                            className="d-block"
                          >
                            {errorMessage}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>

                      {/* Buttons */}
                      <div className="d-flex justify-content-between gap-2">
                        <Button variant="light" className="btn-sec-v">
                          Cancel
                        </Button>
                        <Button
                          className="btn-sec-v"
                          color="#60B1FF"
                          onClick={handleCollegeList}
                        >
                          Continue
                        </Button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Container>
      <div className="d-none d-lg-block">
        <Footer />
      </div>
    </Layout>
  );
};

export default Colleges;
